const SESSION_KEY = "driverAppSession";

export function fusionLoginUrl() {
  const host = process.env.REACT_APP_ADMIN_HOST || "";
  return `${host.replace(/\/$/, "")}/login`;
}

function decodeBase64Url(value) {
  const body = value.replace(/-/g, "+").replace(/_/g, "/");
  const padded = body + "=".repeat((4 - (body.length % 4)) % 4);
  const binary = atob(padded);
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

function decodePayload(token) {
  if (!token || token.indexOf(".") === -1) {
    return null;
  }

  try {
    const payload = JSON.parse(decodeBase64Url(token.split(".")[1]));
    if (!payload || !payload.exp || !payload.role) {
      return null;
    }
    if (payload.role === "driver" && !payload.unique_id) {
      return null;
    }
    if (payload.exp * 1000 <= Date.now()) {
      return null;
    }
    if (!["driver", "admin", "super"].includes(payload.role)) {
      return null;
    }
    return payload;
  } catch (e) {
    return null;
  }
}

function readTokenFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");
  if (!token) {
    return null;
  }

  params.delete("token");
  const query = params.toString();
  const next =
    window.location.pathname +
    (query ? `?${query}` : "") +
    window.location.hash;
  window.history.replaceState({}, "", next);
  return token;
}

function storeSession(token, payload) {
  localStorage.setItem(
    SESSION_KEY,
    JSON.stringify({
      token,
      ...payload,
    })
  );
  localStorage.removeItem("auth");

  if (payload.role === "driver") {
    localStorage.setItem(
      "driver",
      JSON.stringify({
        id: payload.unique_id,
        name: payload.name,
      })
    );
  }
}

export function clearSession() {
  localStorage.removeItem(SESSION_KEY);
  localStorage.removeItem("auth");
  localStorage.removeItem("driver");
}

export function getSession() {
  const raw = localStorage.getItem(SESSION_KEY);
  if (!raw) {
    return null;
  }

  try {
    const stored = JSON.parse(raw);
    const payload = decodePayload(stored.token);
    if (!payload) {
      return null;
    }
    return {
      token: stored.token,
      ...payload,
    };
  } catch (e) {
    return null;
  }
}

export function establishSession() {
  const urlToken = readTokenFromUrl();
  if (urlToken) {
    const payload = decodePayload(urlToken);
    if (!payload) {
      clearSession();
      return null;
    }
    storeSession(urlToken, payload);
    return getSession();
  }

  const session = getSession();
  if (!session) {
    clearSession();
    return null;
  }

  storeSession(session.token, session);
  return session;
}

export function isDriverRole() {
  const session = getSession();
  return session && session.role === "driver";
}

export function authHeader() {
  const session = getSession();
  if (!session) {
    return {};
  }
  return {
    Authorization: `Bearer ${session.token}`,
  };
}

export function redirectToFusionLogin() {
  const host = process.env.REACT_APP_ADMIN_HOST;
  if (!host) {
    return;
  }

  clearSession();
  const url = fusionLoginUrl();
  if (window.location.href.replace(/\/$/, "") === url.replace(/\/$/, "")) {
    return;
  }
  window.location.href = url;
}
